import { useIntl } from "react-intl";
import { ActivityDetailsCheckingAccountMovementProps } from "./types";
import { messages } from "./messages";
import { useFormatter } from "hooks/utils/useFormatter";
import dayjs from "dayjs";
import { ActivityDetailField } from "../ActivityDetailField";
import { DownloadActivityEscoCoupon } from "../ActivityDetailsCoupon/components/DownloadActivityEscoCoupon";

export const ActivityDetailsCheckingAccountMovement: React.FC<
  ActivityDetailsCheckingAccountMovementProps
> = ({ data }) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();

  const movement = data.data;

  return (
    <div className="flex flex-col gap-y-6 pdf:p-10">
      <h2 className="text-2xl font-bold text-[--milkylb-color-neutral-400]">
        {movement.detail}
      </h2>
      <ActivityDetailField
        separator
        label={formatMessage(messages.agreementLabel)}
        value={dayjs(movement.agreement_date).format("DD.MM.YYYY HH:mm")}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.liquidationLabel)}
        value={dayjs(movement.settlement_date).format("DD.MM.YYYY HH:mm")}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.quantityLabel)}
        value={formatValue(movement.nominal_amount.toString())}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.priceLabel)}
        value={`$ ${formatValue(movement.price.toString())} ${movement.movement_currency_symbol.toUpperCase()}`}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.grossLabel)}
        value={`$ ${formatValue(movement.gross_amount.toString())} ${movement.movement_currency_symbol.toUpperCase()}`}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.valuationLabel)}
        value={`$ ${formatValue(movement.net_amount.toString())} ${movement.movement_currency_symbol.toUpperCase()}`}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.marketRightLabel)}
        value={`$ ${formatValue((movement.right - movement.vat_on_right_merc).toString())}  ${movement.movement_currency_symbol.toUpperCase()}`}
      />
      <ActivityDetailField
        separator
        label={formatMessage(messages.ivaLabel)}
        value={`$ ${formatValue(movement.vat_on_right_merc.toString())}  ${movement.movement_currency_symbol.toUpperCase()}`}
      />
      {movement.form_code === "FRMBOL" && (
        <DownloadActivityEscoCoupon couponId={movement.form_key.toString()} />
      )}
    </div>
  );
};
